import styled from 'styled-components';

const Spacer = styled.div`
    font-size: 1.2em;
`;

export default Spacer;